import { T_PRICING_PAGE_CONSTANTS } from './TYPES'

const HU_PRICING_PAGE_CONSTANTS: T_PRICING_PAGE_CONSTANTS = {
  TITLE: 'Előfizetési opciók gyerekek számára',
  DESCRIPTION: [
    {
      label:
        'Mindent magában foglaló előfizetési opciók: Tökéletes minden igényhez!'
    },
    {
      newLine: true,
      label: 'A felnőttek ingyen használják a platformot, a gyerekek pedig'
    },
    {
      label: '15 napon keresztül ingyen próbálhatják azt ki!',
      color: true
    }
  ]
}

export default HU_PRICING_PAGE_CONSTANTS
